
<div class="pagination-controls">
    <button title="First Page" (click)="goToFirstPage()" [disabled]="currentPage === 1">
        <svg width="11" height="13" viewBox="0 0 11 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M10.25 10.75C10.6642 11.1642 10.6642 11.8358 10.25 12.25C9.83579 12.6642 9.16421 12.6642 8.75 12.25L3.79825 7.29825C3.35739 6.85739 3.35739 6.14261 3.79824 5.70176L8.75 0.750001C9.16421 0.335787 9.83579 0.335787 10.25 0.75C10.6642 1.16421 10.6642 1.83579 10.25 2.25L6.3271 6.1729C6.14645 6.35355 6.14645 6.64645 6.3271 6.8271L10.25 10.75Z"
                fill="#3774E8" />
            <path d="M1 12L0.999999 1" stroke="#3774E8" stroke-width="2" stroke-linecap="round" />
        </svg>

    </button>
    <button title="Previous" (click)="prevPage()" [disabled]="currentPage === 1">
        <svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M7.25 10.75C7.66421 11.1642 7.66421 11.8358 7.25 12.25C6.83579 12.6642 6.16421 12.6642 5.75 12.25L0.944444 7.44445C0.422842 6.92284 0.422841 6.07716 0.944444 5.55556L5.75 0.750001C6.16421 0.335787 6.83579 0.335787 7.25 0.75C7.66421 1.16421 7.66421 1.83579 7.25 2.25L3.28302 6.21698C3.12671 6.37329 3.12671 6.62671 3.28302 6.78302L7.25 10.75Z"
                fill="#3774E8" />
        </svg>

    </button>
    <span>Page {{ currentPage }} of {{ totalPages }}</span>
    <button title="Next" (click)="nextPage()" [disabled]="currentPage === totalPages">
        <svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M0.749999 2.25C0.335786 1.83579 0.335787 1.16421 0.75 0.75C1.16421 0.335787 1.83579 0.335786 2.25 0.75L7.20175 5.70175C7.64261 6.14261 7.64261 6.85739 7.20175 7.29825L2.25 12.25C1.83579 12.6642 1.16421 12.6642 0.75 12.25C0.335787 11.8358 0.335786 11.1642 0.75 10.75L4.6729 6.8271C4.85355 6.64645 4.85355 6.35355 4.6729 6.1729L0.749999 2.25Z"
                fill="#3774E8" />
        </svg>

    </button>
    <button title="Last Page" (click)="goToLastPage()" [disabled]="currentPage === totalPages">
        <svg width="11" height="13" viewBox="0 0 11 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M0.749999 2.25C0.335786 1.83579 0.335787 1.16421 0.75 0.75C1.16421 0.335787 1.83579 0.335786 2.25 0.75L7.20175 5.70175C7.64261 6.14261 7.64261 6.85739 7.20175 7.29825L2.25 12.25C1.83579 12.6642 1.16421 12.6642 0.75 12.25C0.335787 11.8358 0.335786 11.1642 0.75 10.75L4.6729 6.8271C4.85355 6.64645 4.85355 6.35355 4.6729 6.1729L0.749999 2.25Z"
                fill="#3774E8" />
            <path d="M10 1L10 12" stroke="#3774E8" stroke-width="2" stroke-linecap="round" />
        </svg>

    </button>
<!-- 
    <label>
        Items per page:
        <select [(ngModel)]="itemsPerPage" (change)="onItemsPerPageChange()">
            <option *ngFor="let option of itemsPerPageOptions" [value]="option">{{ option }}</option>
        </select>
    </label> -->
</div>